var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlus = function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconPlus",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.17323 17.00787"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "thickStroke",
    x1: 3.65221,
    y1: 8.42821,
    x2: 10.52102,
    y2: 8.42821
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "thickStroke",
    x1: 7.08661,
    y1: 4.99381,
    x2: 7.08661,
    y2: 11.86261
  })));
};
export default SvgIconPlus;